export const attachmentsKeys = {
  all: () => ["attachments"],
  list: (targetType, targetId) => [...attachmentsKeys.all(), "list", targetType, targetId]
};
